import { LiveAgentsGate, requireLiveAgentsEnabled } from "~/components/live-agents-gate";
import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { LiveAgentFormPage } from "~/pages/LiveAgentFormPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/live-agents_/create")({
  beforeLoad: requireLiveAgentsEnabled,
  component: () => (
    <LiveAgentsGate>
      <RouteComponent />
    </LiveAgentsGate>
  ),
});

function RouteComponent() {
  const { datasetSlug } = Route.useParams();
  useBreadCrumbs([
    { title: "Settings", link: `/${datasetSlug}/settings/api` },
    { title: "Live Agents", link: `/${datasetSlug}/settings/live-agents` },
    { title: "Create", link: `/${datasetSlug}/settings/live-agents/create` },
  ]);
  return <LiveAgentFormPage />;
}
